/**
 * How a Google link attempt came back, read once out of the address bar. See
 * `githubLink.ts` — same reasoning, Google's outcomes in place of GitHub's.
 */
export interface GoogleLinkOutcome {
  ok: boolean
  message: string
}

const OUTCOMES: Record<string, GoogleLinkOutcome> = {
  linked: { ok: true, message: 'Google linked. You can sign in with it from now on.' },
  taken: {
    ok: false,
    message: 'That Google account is already linked to another stagepost account. Unlink it there first.',
  },
  failed: { ok: false, message: 'Google did not finish that. Nothing changed — try again.' },
}

const GENERIC: GoogleLinkOutcome = { ok: false, message: 'That did not work. Try again.' }

/**
 * Read `?google_link=`, then take it out of the address bar. See
 * `consumeGithubLink` — same reasoning.
 */
export function consumeGoogleLink(): GoogleLinkOutcome | null {
  if (typeof window === 'undefined') return null
  const found = new URLSearchParams(window.location.search).get('google_link')
  if (!found) return null

  const url = new URL(window.location.href)
  url.searchParams.delete('google_link')
  window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`)

  return OUTCOMES[found] ?? GENERIC
}
